const prevent = (e: Event) => {
	e.preventDefault?.()
	e.stopPropagation?.()
}

const isIOS = () => /iPad|iPhone/.test(navigator.userAgent)
let savedScrollPosition: number | null = null
export function lockBodyScroll() {
	savedScrollPosition = window.scrollY
	document.body.style.top = `-${savedScrollPosition}px`
	if (document && isIOS()) {
		// Prevent send scrolling event to ios browsers on touch devices when the dialog is open
		document.addEventListener('touchstart', prevent)
	}
}

export function unlockBodyScroll() {
	if (document && isIOS()) {
		document.removeEventListener('touchstart', prevent)
	}
	document.body.removeAttribute('style')
	if (savedScrollPosition) {
		window.scrollTo(0, savedScrollPosition)
		savedScrollPosition = null
	}
}
